import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const STORAGE_KEY = "elabs_dashboard_passcode";

export function getStoredPasscode() {
  try {
    return localStorage.getItem(STORAGE_KEY) || "";
  } catch {
    return "";
  }
}

export function setStoredPasscode(code) {
  try {
    localStorage.setItem(STORAGE_KEY, code);
  } catch {
    /* ignore */
  }
}

export function clearStoredPasscode() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const code = getStoredPasscode();
  if (code) config.headers["X-App-Auth"] = code;
  return config;
});

export async function verifyPasscode(passcode) {
  const res = await axios.post(`${API}/auth/verify`, { passcode });
  return res.data;
}

export async function getApiKeyStatus() {
  const res = await api.get("/config/apikey");
  return res.data;
}

export async function saveApiKey(api_key) {
  const res = await api.post("/config/apikey", { api_key });
  return res.data;
}

export async function deleteApiKey() {
  const res = await api.delete("/config/apikey");
  return res.data;
}

export async function getPlanConfig() {
  const res = await api.get("/config/plan");
  return res.data;
}

export async function setPlanConfig(plan_usd_monthly) {
  const res = await api.post("/config/plan", { plan_usd_monthly });
  return res.data;
}

export async function startSync() {
  const res = await api.post("/sync/run");
  return res.data;
}

export async function getSyncStatus() {
  const res = await api.get("/sync/status");
  return res.data;
}

export async function getSyncLogs() {
  const res = await api.get("/sync/logs");
  return res.data;
}

export async function listConversations(params = {}) {
  const res = await api.get("/conversations", { params });
  return res.data;
}

export async function listUsers(params = {}) {
  const res = await api.get("/users", { params });
  return res.data;
}

export async function getConversation(id) {
  const res = await api.get(`/conversations/${id}`);
  return res.data;
}

export async function getFacets() {
  const res = await api.get("/facets");
  return res.data;
}

export async function getCategoryStats() {
  const res = await api.get("/stats/categories");
  return res.data;
}

export async function getMonthStats() {
  const res = await api.get("/stats/months");
  return res.data;
}

export async function archiveOldRecords(days = 30) {
  const res = await api.post(`/admin/archive-old?days=${days}`);
  return res.data;
}

export async function backfillPhones() {
  const res = await api.post("/admin/backfill-phones");
  return res.data;
}

export function buildCsvUrl(params = {}) {
  const usp = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") usp.set(k, v);
  });
  usp.set("token", getStoredPasscode());
  return `${API}/export/csv?${usp.toString()}`;
}

export function buildUsersCsvUrl(params = {}) {
  const usp = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") usp.set(k, v);
  });
  usp.set("token", getStoredPasscode());
  return `${API}/export/users-csv?${usp.toString()}`;
}

export async function getCreditStats() {
  const res = await api.get("/stats/credits");
  return res.data;
}

export function formatCompactNumber(n) {
  if (n === null || n === undefined || n === "") return "—";
  const num = Number(n);
  if (Number.isNaN(num)) return String(n);
  if (Math.abs(num) >= 1_000_000) return (num / 1_000_000).toFixed(2).replace(/\.?0+$/, "") + "M";
  if (Math.abs(num) >= 1_000) return (num / 1_000).toFixed(1).replace(/\.?0+$/, "") + "K";
  return num.toLocaleString();
}

export function formatDuration(seconds) {
  if (!seconds && seconds !== 0) return "—";
  const s = Math.floor(seconds % 60);
  const m = Math.floor((seconds / 60) % 60);
  const h = Math.floor(seconds / 3600);
  if (h > 0) return `${h}h ${m}m ${s}s`;
  if (m > 0) return `${m}m ${s.toString().padStart(2, "0")}s`;
  return `${s}s`;
}

export function formatCredits(v) {
  if (v === null || v === undefined || v === "") return "—";
  const n = Number(v);
  if (Number.isNaN(n)) return String(v);
  return `${n.toLocaleString()} cr`;
}

export function formatUsd(v) {
  if (v === null || v === undefined || v === "") return "—";
  const n = Number(v);
  if (Number.isNaN(n)) return String(v);
  if (n === 0) return "$0.00";
  if (n < 0.01) return `$${n.toFixed(6)}`;
  return `$${n.toFixed(4)}`;
}

export function formatCost(v) {
  if (v === null || v === undefined) return "—";
  if (typeof v !== "number") return String(v);
  return `$${v.toFixed(4)}`;
}

export function formatDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString(undefined, {
      year: "numeric",
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
}
